import React, {useEffect, useState} from 'react';
import {Controller} from 'react-hook-form';
import {Autocomplete, CircularProgress, TextField, Typography} from '@mui/material';
import {customEventServices} from '../../service/customEventService';
import {getSettingsColors} from '../settings/SettingsDesign';

export default function LogCustomConversionSelect({control, disabled, onChange}) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const selectId = React.useId();

    useEffect(() => {
        if (!open) return;
        let active = true;
        setLoading(true);
        setLoadError(false);
        customEventServices.fetch({}).then(events => {
            if (!active) return;
            const seen = new Set();
            setOptions((events || []).filter(event => event.isActive !== false).flatMap(event =>
                (event.events || '').split(',').map(value => value.trim()).filter(value => {
                    if (!value || seen.has(value)) return false;
                    seen.add(value);
                    return true;
                }).map(value => ({value, name: event.name}))));
        }).catch(() => {if (active) {setOptions([]); setLoadError(true);}})
            .finally(() => {if (active) setLoading(false);});
        return () => {active = false;};
    }, [open]);

    return <Controller control={control} name="ce" defaultValue="" render={({field}) =>
        <Autocomplete id={selectId} fullWidth size="small" disabled={disabled} open={open}
            onOpen={() => setOpen(true)} onClose={() => setOpen(false)}
            options={options} loading={loading} openText="Open custom conversions"
            value={field.value ? {value: field.value} : null}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={option => option.value}
            noOptionsText={loadError ? 'Unable to load custom conversions. Reopen to retry.' : 'No matching custom conversions.'}
            onChange={(event, option) => {field.onChange(option?.value || ''); onChange();}}
            onBlur={field.onBlur}
            slotProps={{paper: {sx: {bgcolor: theme => getSettingsColors(theme).card, color: 'text.primary',
                borderRadius: '12px', border: '1px solid', borderColor: 'divider',
                '& .MuiAutocomplete-option': {fontSize: 13, py: 1}, '& .MuiAutocomplete-noOptions': {fontSize: 13}}}}}
            renderOption={(props, option) => {
                const {key, ...optionProps} = props;
                return <li key={key} {...optionProps}><span>{option.value}
                    <Typography component="span" sx={{display: 'block', fontSize: 11, color: 'text.secondary'}}>{option.name}</Typography>
                </span></li>;
            }}
            renderInput={params => <TextField {...params} inputRef={field.ref} name={field.name}
                label="Custom conversion (optional)" placeholder="Select a custom conversion" error={loadError}
                helperText={loadError ? 'Unable to load custom conversions. Reopen the list to retry.' : 'Leave blank for a standard conversion.'}
                slotProps={{inputLabel: {shrink: true}, input: {...params.InputProps,
                    endAdornment: <>{loading && <CircularProgress size={16} color="inherit"/>}{params.InputProps.endAdornment}</>}}}/>}
        />}/>;
}
